import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { Observable } from 'rxjs';
import { map, mergeMap, take, tap } from 'rxjs/operators';
import { User } from './models';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from './user.service';
import * as URI from 'urijs';

@Injectable()
export class TokenExchangeService {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private sessionService: SessionService
  ) { }

  exchange(): Observable<User> {
    return this.hasFragment().pipe(
      mergeMap((hasFragment) => {
        if (hasFragment) {
          return this.resolveUserFromNonce();
        }

        return this.resolveUserFromToken();
      }),
      take(1),
      tap(this.validate)
    );
  }

  private hasFragment(): Observable<boolean> {
    return this.route.fragment
      .pipe(
        map(fragment => {
          return !!fragment;
        })
      );
  }

  private resolveUserFromNonce(): Observable<User> {
    return this.route
      .fragment
      .pipe(
        map(x => URI(x).segment(-1)),
        mergeMap((token) => {
          return this.userService.nonceLogin(token);
        })
      );
  }

  private resolveUserFromToken(): Observable<User> {
    const tokenY = this.route.snapshot.queryParams['y'];
    const tokenT = this.route.snapshot.queryParams['t'];

    if (tokenY) {
      setTimeout(() => {
        this.sessionService.setAccount(null);
      }, 100);
      return this.userService.accessTokenLogin(tokenY);
    }

    if (tokenT) {
      setTimeout(() => {
        this.sessionService.setAccount(null);
      }, 100);
      return this.userService.impersonatedLogin(tokenT);
    }
    return this.sessionService.user;
  }

  private validate(user: User): User {
    if (!user) {
      throw new Error('User not found');
    }

    return user;
  }

}
